(function () {
    'use strict';

    function main() {

        var page = wo$('#product');
        if (!page.length) return;

        var productController = {

            init: function () {

                page.find('[data-gallery]').each(function () {
                    wo$(this).magnificPopup({
                        delegate: 'a[data-gallery-item]',
                        type: 'image',
                        zoom: {
                            enabled: true,
                            duration: 400
                        },
                        gallery: {
                            enabled: true
                        }
                    });
                });

                page.find('a[data-gallery-opener]').click(function () {
                    wo$(this).parents('[data-gallery]').find('a[data-gallery-item]').last().click();
                });

                page.find('#product-phones-filter input:checked').click(function () {
                    productController.filterPhones();
                });

                page.find('#product-phones-sort').change(function () {
                    productController.sortPhones();
                });

                page.find('#product-cta-sticky').affix({
                    offset: {
                        top: function () {
                            return page.find('#nav-strip').offset().top;
                        }
                    }
                });

                page.find('[data-show-only-price-type]').click(function () {
                    var priceType = wo$(this).data('show-only-price-type');
                    page.find('#product-phones-filter input:checkbox').each(function () {
                        if (wo$(this).val() === priceType) {
                            wo$(this).prop('checked', true);
                        } else {
                            wo$(this).prop('checked', false);
                        }
                        productController.filterPhones();
                    });
                });

                page.find('[data-hide-all-price-type]').click(function () {
                    var priceType = wo$(this).data('hide-all-price-type');
                    page.find('#product-phones-filter input:checkbox').each(function () {
                        if (wo$(this).val() === priceType) {
                            wo$(this).prop('checked', false);
                        }
                        productController.filterPhones();
                    });
                });

                var showCallback = page.attr('data-show-callback').toLowerCase() === 'true';
                if (showCallback) {
                    page.find('#callback').click();
                }

                WhistleOut.getAds('MobilePhones');
            },

            filterPhones: function () {
                var options = [];
                page.find('#product-phones-filter input:checkbox:checked').each(function () {
                    options.push(wo$(this).val());
                });

                page.find('#product-phones-list>div').each(function () {
                    var $this = wo$(this);
                    $this.toggle(options.indexOf($this.attr('data-type')) >= 0);
                });
            },

            sortPhones: function () {
                var sort = page.find('#product-phones-sort').val();
                var items = page.find('#product-phones-list>div');

                switch (sort) {
                    case '1':
                        items.tsort({ attr: 'data-name' });
                        break;
                    case '2':
                        items.tsort({ attr: 'data-popularity' }, { attr: 'data-price' });
                        break;
                    case '3':
                        items.tsort({ attr: 'data-price' }, { attr: 'data-name' });
                        break;
                    case '4':
                        items.tsort({ attr: 'data-price', order: 'desc' }, { attr: 'data-name' });
                        break;
                }
            }

        };

        productController.init();
    };

    WhistleOut.initModule(import.meta.url, main);

}());